import styled from '@emotion/styled';

import { tokens, Text, Stack } from '@hotjar/hotsauce';

const PriceValue = styled(Text)`
  margin: 0 ${tokens.spacer.x0};
  color: inherit;
`;

export const PlanPriceStyles = {
  StrikethroughPrice: styled(Text)`
    ${tokens.text('caption')};
    color: ${tokens.color.text_disabled};
    text-decoration: line-through;
  `,
  Price: styled(Text)`
    ${tokens.text('subtitle2')}
    display: flex;
    align-items: baseline;
    color: inherit;
  `,
  PriceValue,
  BilledAnnuallyLabel: styled(Text)`
    ${tokens.text('caption')};
    color: ${tokens.color.text_disabled};
    text-align: right;
  `,
  PriceWrapper: styled(Stack)`
    align-items: flex-end;
  `,
  DiscountedPrice: styled(Text)`
    ${tokens.text('subtitle2')}
    display: flex;
    align-items: baseline;

    ${PriceValue} {
      color: ${tokens.color.text_success};
    }
  `,
};
